import { Country, CustomerAddress } from '@bigcommerce/checkout-sdk'
import { CompanyBasicInfo } from './../../request/apis'
import { 
  SET_COMPANY_BASIC_INFO,
  SET_DEFAULT_SHIPPING_ADDRESS,
  SET_DEFAULT_BILLING_ADDRESS,
  SET_COUNTRIES,
  SET_ADDRESSES,
  SET_BASIC_ADDRESS_INFO,
} from '../actionTypes'

declare interface CompanyAction {
  type: string
  payload: any
}

export const setCompanyBasicInfo = (companyBasicInfo: CompanyBasicInfo): CompanyAction => ({
  type: SET_COMPANY_BASIC_INFO,
  payload: companyBasicInfo,
})

export const setDefaultShippingAddress = (shipping: CustomerAddress): CompanyAction => ({
  type: SET_DEFAULT_SHIPPING_ADDRESS,
  payload: shipping,
})

export const setDefaultBillingAddress = (billing: CustomerAddress): CompanyAction => ({
  type: SET_DEFAULT_BILLING_ADDRESS,
  payload: billing,
})

export const setCountries = (countries: Country[]): CompanyAction => ({
  type: SET_COUNTRIES,
  payload: countries,
})

export const setAddresses = (addresses: CustomerAddress[]): CompanyAction => ({
  type: SET_ADDRESSES,
  payload: addresses,
})

export const setBasicAddressInfo = (address: CustomerAddress): CompanyAction => ({
  type: SET_BASIC_ADDRESS_INFO,
  payload: address,
})

